
import { useState } from 'react'
import { useToast } from '@/hooks/use-toast'
import { supabase } from '@/integrations/supabase/client'
import { useAuth } from '@/components/auth/AuthProvider'
import { Tables } from '@/integrations/supabase/types'

export function useDocumentAnalysis() {
  const [isAnalyzing, setIsAnalyzing] = useState(false)
  const { toast } = useToast()
  const { user } = useAuth()

  const analyzeDocument = async (documentId: string, content: string) => {
    setIsAnalyzing(true)
    try {
      if (!user) {
        throw new Error('User must be authenticated to analyze documents')
      }

      const { data, error } = await supabase.functions.invoke('analyze-document', {
        body: { 
          documentId, 
          content,
          userId: user.id 
        }
      })

      if (error) throw error

      toast({
        title: "Analysis complete",
        description: "Document has been analyzed successfully.",
      })

      return data.result as Tables<'document_analysis_results'>
    } catch (error) {
      console.error('Error analyzing document:', error)
      toast({
        variant: "destructive",
        title: "Analysis failed",
        description: "Could not complete document analysis. Please try again.",
      })
      throw error
    } finally {
      setIsAnalyzing(false)
    }
  }

  return {
    isAnalyzing,
    analyzeDocument
  }
}
